module.exports = fox._r("var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/mobile/images/notification.png", __webpack_public_path__ + "_/_/_/common/components/mobile/images/notification.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/mobile/images/notification.png
// module id = 605
// module chunks = 2